import React, { useState, useEffect } from "react";
import { Grid, Typography, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";
import PrePlanting from "../../assets/images/preplanting2.png";
import Planting from "../../assets/images/PlantingActivity2.png";
import Germination from "../../assets/images/Germination2.png";
import StripTest from "../../assets/images/StripTest2.png";
import DayWise from "../../assets/images/DayWiseActivity2.png";
import Harvesting from "../../assets/images/Harvesting2.png";
import CustomButton from "../../components/Custom/CustomButton";
import RougingIcon from "../../assets/images/RougingIcon.png";
import DehaulmingIcon from "../../assets/images/DehaulmingIcon.png";
import AbnormilityIcon from "../../assets/images/AbnormilityIcon.png";
import { useAlert } from "../../components/Alert";
// Component
import GerminationPopup from "../../components/plot_engagement/Popup/GerminationPopup";
import StripTestPopup from "../../components/plot_engagement/Popup/StripTestPopup";
import RougingPopup from "../../components/plot_engagement/Popup/RougingPopup";
import DehaulmingPopup from "../../components/plot_engagement/Popup/DehaulmingPopup";
import AbnormilityPopup from "../../components/plot_engagement/Popup/Abnormility";
import Loader from "../../components/Loader";
import { useTranslation } from "react-i18next";

const ImageGrid = ({ farmerPlotId, variety, data, onImagesLoad }) => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [isGerminationPopupOpen, setIsGerminationPopupOpen] = useState(false);
  const [isRougingPopupOpen, setIsRougingPopupOpen] = useState(false);
  const [isStripTestPopupOpen, setIsStripTestPopupOpen] = useState(false);
  const [isDehaulmingPopupOpen, setIsDehaulmingPopupOpen] = useState(false);
  const [isAbnormilityPopupOpen, setIsAbnormilityPopupOpen] = useState(false);

  const [allImagesLoaded, setAllImagesLoaded] = useState(false);
  const { showAlert } = useAlert();
  const [dateOfPlanting, setDateOfPlanting] = useState(false);
  const { t } = useTranslation();

  const images = [
    {
      id: 1,
      src: PrePlanting,
      alt: t("Pre Planting Activity"),
      route: "/activity/PrePlanting/",
    },
    {
      id: 2,
      src: Planting,
      alt: t("Planting Activity"),
      route: "/activity/planting-activity/",
    },
    { id: 3, src: Germination, alt: t("Germination") },
    { id: 4, src: RougingIcon, alt: t("Rouging") },
    { id: 5, src: DehaulmingIcon, alt: t("Dehaulming") },
    { id: 6, src: StripTest, alt: t("StripTest") },
    { id: 7, src: AbnormilityIcon, alt: t("Abnormility") },
    {
      id: 8,
      src: DayWise,
      alt: t("DayWise Activity"),
      route: "/activity/daywise-activity/",
    },
    {
      id: 9,
      src: Harvesting,
      alt: t("Harvesting"),
      route: "/activity/harvesting/",
    },
  ].filter((image) => {
    if (image.id === 4 || image.id === 5 || image.id == 7) {
      return false;
    }
    return true;
  });
  const queryParams = new URLSearchParams(location.search);
  const openPopup = queryParams.get("openPopup");

  const setOpenPopupType = () => {
    if (openPopup === t("Germination")) {
      setIsGerminationPopupOpen(true);
    }
    if (openPopup === t("StripTest")) {
      setIsStripTestPopupOpen(true);
    }
    if (openPopup === t("Rouging")) {
      setIsStripTestPopupOpen(true);
    }
    if (openPopup === t("Abnormility")) {
      setIsStripTestPopupOpen(true);
    }
    if (openPopup === t("Dehaulming")) {
      setIsStripTestPopupOpen(true);
    }
  };

  useEffect(() => {
    setOpenPopupType();
  }, [openPopup]);

  const handleImageClick = (route, alt) => {
    if (alt === t("StripTest") && dateOfPlanting) {
      setIsStripTestPopupOpen(true);
    } else if (alt === t("StripTest") && !dateOfPlanting) {
      showAlert("warning", "You need to set the date of planting first.");
    } else if (alt === t("Germination")) {
      setIsGerminationPopupOpen(true);
    } else if (alt === t("Rouging")) {
      setIsRougingPopupOpen(true);
    } else if (alt === t("Abnormility")) {
      setIsAbnormilityPopupOpen(true);
    } else if (alt === t("Dehaulming")) {
      setIsDehaulmingPopupOpen(true);
    } else {
      navigate(route, { state: { farmerPlotId, variety } });
    }
  };

  const handleClosePopup = () => {
    setIsGerminationPopupOpen(false);
    setIsStripTestPopupOpen(false);
    setIsDehaulmingPopupOpen(false);
    setIsAbnormilityPopupOpen(false);
    setIsRougingPopupOpen(false);
  };
  const preloadImages = () => {
    const imagePromises = images.map((image) => {
      return new Promise((resolve, reject) => {
        const img = new Image();
        img.onload = () => resolve();
        img.onerror = () => reject();
        img.src = image.src;
      });
    });

    Promise.allSettled(imagePromises)
      .then(() => {
        setIsLoading(false);
        setAllImagesLoaded(true);
      })
      .catch((error) => {
        setIsLoading(false);
        console.error(error);
      });
  };
  useEffect(() => {
    const loadImages = async () => {
      try {
        if (data && data.planting) {
          setDateOfPlanting(data.planting[0].planting);
        }
        preloadImages();
      } catch (error) {
        console.error("Error loading images:", error);
        setIsLoading(false);
      }
    };

    loadImages();
  }, [data]);
  useEffect(() => {
    if (allImagesLoaded && onImagesLoad) {
      onImagesLoad();
    }
  }, [allImagesLoaded, onImagesLoad]);

  return (
    <div>
      <Typography variant="h5" align="center" gutterBottom></Typography>
      {isLoading ? (
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          minHeight="200px"
          height="200px"
        >
          <Loader />
        </Box>
      ) : (
        <Grid container spacing={2} justifyContent="center">
          {images.map((image) => (
            <Grid item key={image.id} xs={6} md={4} lg={2}>
              <div
                style={{ position: "relative" }}
                onClick={() => handleImageClick(image.route, image.alt)}
              >
                <img
                  src={image.src}
                  alt={image.alt}
                  style={{
                    width: "100%",
                    cursor: "pointer",
                    borderRadius: "10px",
                    backgroundColor: "#f0f0f0",
                  }}
                />
                <div
                  style={{
                    position: "absolute",
                    bottom: 10,
                    left: "50%",
                    width: "160px",
                    transform: "translateX(-50%)",
                  }}
                >
                  <CustomButton backgroundColor="#000" hideIcon>
                    {t(image.alt)}
                  </CustomButton>
                </div>
              </div>
            </Grid>
          ))}
        </Grid>
      )}
      {isGerminationPopupOpen && (
        <GerminationPopup onClose={handleClosePopup} t={t} />
      )}
      {isStripTestPopupOpen && (
        <StripTestPopup onClose={handleClosePopup} t={t} />
      )}
      {isRougingPopupOpen && <RougingPopup onClose={handleClosePopup} t={t} />}
      {isDehaulmingPopupOpen && (
        <DehaulmingPopup onClose={handleClosePopup} t={t} />
      )}
      {isAbnormilityPopupOpen && (
        <AbnormilityPopup onClose={handleClosePopup} t={t} />
      )}
    </div>
  );
};

export default ImageGrid;
